import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormBanIn";
import mushroom from "viettoc-api";
import eventBus from "../../../service/EventBus";
import moment from "moment";
import { Filter } from 'mushroomjs'

export default {
    data() {
        return {
            aLang: LanguageService.lang,
            loading: true,
            mData: {
                tableRules: MethodService.copyObject(DataForm.tableRules),
                trangThai: MethodService.copyObject(DataForm.trangThai), // trạng thái bản in
                donHang: MethodService.copyObject(DataForm.donHang), // trạng thái đơn hàng chốt hay chưa
            },
            // quyền tài khoản đăng nhập
            SalesManagerOrInGiaPhaSales: false,
            CustomerCareUser: false,
            SystemAdmin: false,
            InGiaPhaDesigner: false,
            searchTrangThai: ["gui_yeu_cau", "dang_tu_van", "dang_san_xuat", "dang_giao_hang"],
        };
    },
    components: {
        Circle4,
    },
    methods: {
        async fn_hashUrl() {
            if (this.$route.query.limit) {
                this.mData.tableRules.limit = parseInt(this.$route.query.limit);
            }
            if (this.$route.query.page) {
                this.mData.tableRules.page = parseInt(this.$route.query.page);
            }
            if (this.$route.query.limit && this.$route.query.page) {
                this.mData.tableRules.offset =
                    (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
            }
            if (this.$route.query.sort) {
                this.mData.tableRules.sort = this.$route.query.sort;
                this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
                if (this.mData.tableRules.sort.indexOf("-") != -1) {
                    this.mData.tableRules.defaultSort[1] = "descending";
                } else {
                    this.mData.tableRules.defaultSort[1] = "ascending";
                }
            }
            
            if (this.$route.query.filters) {
                this.mData.tableRules.filters = this.$route.query.filters;
                // string to object
                this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
                    this.mData.tableRules.filters
                );

                const statusDon = this.mData.tableRules.dataSearch.value["don_hang.da_chot_don"];
                this.mData.tableRules.dataSearch.value["don_hang.da_chot_don"] = statusDon == 'true' ? true : statusDon == 'false' ? false : undefined;
            }
            if (this.$route.query.showFormSearch) {
                if (this.$route.query.showFormSearch == "true") {
                    this.mData.tableRules.showFormSearch = true;
                } else this.mData.tableRules.showFormSearch = false;
            }
            
            let textStatus = '';
            if(this.searchTrangThai && !this.mData.tableRules.filters.includes('trang_thai')) {
                textStatus = Filter.in('trang_thai', this.searchTrangThai).build();
                this.mData.tableRules.filters += `&${textStatus}`
            }
            if(this.mData.tableRules.dataSearch.value.trang_thai) {
                this.searchTrangThai = this.mData.tableRules.dataSearch.value.trang_thai.split(',')
                this.mData.tableRules.dataSearch.value.trang_thai = '';
            }
        },
        async fn_initTable() {
            let dataFilter = {
                filters: this.mData.tableRules.filters,
                fields:
                    "id, trang_thai, don_hang, dong_ho_id, user_id, nguoi_dung_id, node_id, nguoi_tao_id, thoi_diem_tao, lich_su, cau_hinh, lien_he, ban_mem, so_luong",
            };
            if (this.mData.tableRules.allowPaging) {
                dataFilter.limit = this.mData.tableRules.limit;
                dataFilter.offset = this.mData.tableRules.offset;
            }
            if (this.mData.tableRules.allowSorting) {
                dataFilter.sort = this.mData.tableRules.sort;
            }
            if (this.mData.tableRules.showUrl) {
                this.$router
                    .replace({
                        name: "DanhSachBanIn",
                        query: {
                            limit: this.mData.tableRules.limit,
                            page: this.mData.tableRules.page,
                            sort: this.mData.tableRules.sort,
                            filters: this.mData.tableRules.filters,
                            showFormSearch: this.mData.tableRules.showFormSearch,
                        },
                    })
                    .catch((err) => { });
            }
 
            try {
                const response = await mushroom.ban_in.listAsync(dataFilter, {
                    cacheAge: 1,
                });
                console.log("danh sách bản in:", response.result);
                this.mData.tableRules.data = response.result;
                this.mData.tableRules.total = response.meta.total;
                this.mData.tableRules.page =
                    response.meta.offset / response.meta.limit + 1;
                this.loading = false;
                eventBus.$emit("doiTrangThaiBanIn");
            } catch (e) {
                this.loading = false;
                MethodService.showError(e.code);
            }
        },
        fn_tableSortChange(column) {
            if (column.order == "ascending") {
                this.mData.tableRules.sort = column.prop;
            } else if (column.order == "descending") {
                this.mData.tableRules.sort = "-" + column.prop;
            } else {
                this.mData.tableRules.sort = "";
            }
            this.fn_initTable();
        },

        // đổi định dạng ngày
        fn_convertDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm");
        },

        // đổi định dạng số điện thoại
        fn_changePhone(phone) {
            return MethodService.changePhone(phone);
        },

        // phân trang
        fn_tableSizeChange(limit) {
            this.mData.tableRules.limit = limit;
            this.fn_tableChangeOffset(this.mData.tableRules.page);
        },
        fn_tableCurentChange(page) {
            this.fn_tableChangeOffset(page);
        },
        fn_tablePrevClick(page) {
            this.fn_tableChangeOffset(page);
        },
        fn_tableNextClick(page) {
            this.fn_tableChangeOffset(page);
        },
        fn_tableChangeOffset(page) {
            this.mData.tableRules.page = page;
            this.mData.tableRules.offset =
                (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
            this.fn_initTable();
        },

        // tìm kiếm
        fn_tableShowFormSearch() {
            this.mData.tableRules.showFormSearch =
                !this.mData.tableRules.showFormSearch;
            this.$router.replace({
                name: "DanhSachBanIn",
                query: {
                    limit: this.mData.tableRules.limit,
                    page: this.mData.tableRules.page,
                    sort: this.mData.tableRules.sort,
                    filters: this.mData.tableRules.filters,
                    showFormSearch: this.mData.tableRules.showFormSearch,
                },
            });
        },
        fn_tableSearch() {
            if (this.mData.tableRules.dataSearch.value["lien_lac.dien_thoai"]) {
                this.mData.tableRules.dataSearch.value["lien_lac.dien_thoai"] =
                    this.mData.tableRules.dataSearch.value["lien_lac.dien_thoai"].trim();
            }
            const statusDon = this.mData.tableRules.dataSearch.value["don_hang.da_chot_don"]
            this.mData.tableRules.dataSearch.value["don_hang.da_chot_don"] = statusDon ? statusDon : statusDon === false ? 'false' : '';
            let textStatus = '';
            if(this.searchTrangThai) {
                textStatus = Filter.in('trang_thai', this.searchTrangThai).build()
            }
            this.loading = true;
            
            this.mData.tableRules.filters = MethodService.filterTable(
                JSON.stringify(this.mData.tableRules.dataSearch)
            );
            if (this.searchTrangThai.length > 0 && !this.mData.tableRules.filters.includes('trang_thai')) {
                this.mData.tableRules.filters += `&${textStatus}`
            } else {
                this.mData.tableRules.filters = MethodService.filterTable(
                    JSON.stringify(this.mData.tableRules.dataSearch)
                );
            }
            this.mData.tableRules.dataSearch.value["don_hang.da_chot_don"] = statusDon ? statusDon : statusDon === false ? false : '';
            this.mData.tableRules.offset = 0;
            this.mData.tableRules.sort = "";
            this.fn_initTable();
            MethodService.stopLadda();
        },

        // xem chi tiết, xóa bảng
        fn_handle(type, scope, row) {
            if (type == "detail") {
                this.$router.push({
                    name: "ChiTietBanIn",
                    params: { id: row.id },
                });
            }
            if (type == "update") {
                this.$router.push({
                    name: "CapNhatBanIn",
                    params: { id: row.id },
                });
            }
        },

        forceUpdateUI() {
            this.$forceUpdate();
        },
        fn_add() {
            this.$router.push({
                name: "ThemMoiBanIn",
            });
        },
    },
    //run after render view
    async created() {
        // kiểm tra loại roles
        if (JSON.parse(localStorage.getItem("currentUser")).roles.includes('InGiaPhaSales') || JSON.parse(localStorage.getItem("currentUser")).roles.includes('SalesManager')) {
            this.SalesManagerOrInGiaPhaSales = true;
        } else this.SalesManagerOrInGiaPhaSales = false
        if (JSON.parse(localStorage.getItem("currentUser")).roles.includes('CustomerCareUser')) {
            this.CustomerCareUser = true;
        } else this.CustomerCareUser = false;

        if (JSON.parse(localStorage.getItem("currentUser")).roles.includes('SystemAdmin')) {
            this.SystemAdmin = true;
        } else this.SystemAdmin = false;
        if (JSON.parse(localStorage.getItem("currentUser")).roles.includes('InGiaPhaDesigner')) {
            this.InGiaPhaDesigner = true;
        } else this.InGiaPhaDesigner = false;

        await this.fn_hashUrl();
        await this.fn_initTable();
    },
};